import { DestinationParams } from '@anm/api/modules/stream/types';
import { Logger } from '@anm/helpers/Debugger';
import browserStore from '@anm/helpers/browserStore';
import { userDestinationsActions } from '@anm/store/modules/userDestinations';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import getDestinationStorageKey from '../helpers/getDestinationStorageKey';

const logger = new Logger('destination_storage');

const useStorageChange = () => {
  const dispatch = useDispatch();
  const storageKey = getDestinationStorageKey();

  const onStorageChange = (event: StorageEvent) => {
    if (event.key !== storageKey) return;

    try {
      const params = browserStore.get(storageKey) as DestinationParams;

      if (!params) return;

      const destinationType = params.type;
      const destinationId = params.destinationId;
      const canLoadWithQuery = !!(destinationType && destinationId);
      const query = canLoadWithQuery ? `/load?destinationId=${destinationId}&socialKind=${destinationType}` : '';

      dispatch(userDestinationsActions.fetchDestinationsList({ query }));
    } catch {
      logger.error('Error getting params from local storage');
    }
  };

  useEffect(() => {
    window.addEventListener('storage', onStorageChange);

    return () => {
      window.removeEventListener('storage', onStorageChange);
    };
  }, []);
};

export default useStorageChange;
